import { Link } from 'react-router-dom'

interface BrandLogoProps {
  /** Show tagline below the brand name */
  showTagline?: boolean
  /** Link to home - if false, renders as div instead of Link */
  linkToHome?: boolean
  /** Logo height in Tailwind class (e.g. h-10, h-12) */
  size?: 'sm' | 'md' | 'lg'
  /** Layout: horizontal (logo + text side by side) or stacked (for centered login) */
  layout?: 'horizontal' | 'stacked'
  className?: string
}

const sizeClasses = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
}

export default function BrandLogo({
  showTagline = false,
  linkToHome = true,
  size = 'md',
  layout = 'horizontal',
  className = '',
}: BrandLogoProps) {
  const content = (
    <div
      className={`flex items-center gap-3 ${layout === 'stacked' ? 'flex-col' : ''} ${className}`}
    >
      <img
        src="/LoanLoopLogo.jpg"
        alt="LoanLoop"
        className={`${sizeClasses[size]} w-auto`}
      />
      <div className={layout === 'stacked' ? 'text-center' : 'flex flex-col'}>
        <span className="text-2xl font-bold text-primary-600">LoanLoop</span>
        {showTagline && (
          <p className="text-sm text-gray-500 mt-0.5">
            Close the loop on your home loan.
          </p>
        )}
      </div>
    </div>
  )

  if (linkToHome) {
    return (
      <Link to="/" className="hover:opacity-90 transition-opacity">
        {content}
      </Link>
    )
  }

  return content
}
